const config = {
	SETTING_HOST_MESSAGING: 'messaging.deezer.com',
	API_HOST: 'api-music-analytics.deezer.com',
	LEGACY_API_HOST:
		process.env.LEGACY_BASE_URL ||
		process.env.NEXT_PUBLIC_LEGACY_BASE_URL ||
		'backstage.deezer.com',
	PODCAST_HOST_API: process.env.PODCAST_HOST_API,
	segment_api_key: 'glEdONzDdVv0NVmmYwhuLlEgcW1pd0VY',
	didomi_public_key: 'e6821e54-c6d5-43cc-a38a-f2b978d39fc5',
	host_img_url_ssl: 'cdn-images.dzcdn.net/images',
	host_website_ssl: 'www.deezer.com',
} as const;

export default config;
